<template>
  <div>
    <article>
      <h1 class="title">{{$t('navigation.member')}}</h1>
      <h2 class="subtitle">{{ $route.params.path }}</h2>
      <div
        class="tile is-ancestor artwork"
        v-for="row in rows(images)"
        :key="row.id"
      >
        <div class="tile is-parent is-2" v-for="child in row" :key="child.id">
          <article class="tile is-child box">
            <h5 class="title is-5" v-html="child.name"></h5>
            <a
              target="_blank"
              v-if="child.is_downloadable"
              @click="getImage(child.name, child.path_display)"
            >
              <img :src="getThumbnail(child.path_display)" />
              <div class="is-size-6">{{ humanFileSize(child.size, true) }}</div>
            </a>
            <router-link
              v-if="child['.tag'] == 'folder'"
              :to="{ name: 'Member', params: { path: child.path_display } }"
            >
              <svg
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                ></path>
              </svg>
            </router-link>
          </article>
        </div>
      </div>
    </article>
    <div id="header"></div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "member",
  data() {
    return {
      images: [],
      links: {},
    };
  },
  mounted() {
    this.getImages(this.$route.params.path ?? "/");
  },
  watch: {
    $route() {
      this.getImages(this.$route.params.path ?? "/");
    },
  },
  methods: {
    getThumbnail(path_display) {
      return (
        process.env.VUE_APP_API_URL_EN +
        "wp-json/blackdigital/v1/member/thumbnail" +
        path_display
      );
    },
    async getImage(name, path_display) {
      let response = await axios.get(
        process.env.VUE_APP_API_URL_EN +
          "wp-json/blackdigital/v1/member/highres" +
          path_display,
        {
          headers: { Authorization: "Bearer " + localStorage.token },
          responseType: "arraybuffer",
        }
      );
      var data =
          "data:image/jpeg;base64," +
          Buffer.from(response.data, "binary").toString("base64"),
        a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = data;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(data);
    },
    humanFileSize(bytes, si=false, dp=1) {
        const thresh = si ? 1000 : 1024;

        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }

        const units = si 
            ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let u = -1;
        const r = 10**dp;

        do {
            bytes /= thresh;
            ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


        return bytes.toFixed(dp) + ' ' + units[u];
    },
    rows(obj) {
      var numberOfColumns = 6;
      var rows = [];
      var count = 0;
      var row = [];
      for (var i in obj) {
        count++;
        row.push(obj[i]);
        if (count % numberOfColumns == 0 || i == obj.length - 1) {
          rows.push(row);
          row = [];
        }
      }
      return rows;
    },
    async getImages(path) {
      this.images = [];
      let response = await axios.get(
        process.env.VUE_APP_API_URL_EN +
          "wp-json/blackdigital/v1/member/" +
          path,
        {
          headers: { Authorization: "Bearer " + localStorage.token },
        }
      );
      this.images = response.data.entries;
    },
  },
};
</script>